import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { Statistics } from "action/stat-action";

type StatsDataState = {
    statsData: Statistics;
    setStatsData: (statsData: Statistics) => void;
    deleteStatsData: () => void;
}

export const useStatsData = create<StatsDataState>()(
    persist(
        (set) => ({
            statsData: {
                total_revenue: null, // using this to check if data is available
                total_products_sold_count: 0,
                growth_rate: 0,
                total_orders: 0,
                total_30_day_revenue: 0,
                revenue_chart: [],
                product_stats: [],
                visitors_chart: [],
                conversion_rate: 0,
                average_order_value: 0
            },
            setStatsData: (statsData: Statistics) => set({statsData}),
            deleteStatsData: () => set({statsData: null})
        }),
        {
            name: "stats-data",
            storage: createJSONStorage(() => sessionStorage)
        }
    )
)